import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "worksheet/:classRoomId/:studentAssignmentId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "student-worksheet" */ "./components"),
        import(
          /* webpackChunkName: "student-worksheet" */ "ClassRoom/modules/ClassRoomModule"
        ),
        import(
          /* webpackChunkName: "student-worksheet" */ "Worksheet/modules/WorksheetModules"
        ),
        import(
          /* webpackChunkName: "student-worksheet" */ "Post/modules/PostModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const worksheetModule = importedModule2;
          const post = importedModule3.default;
          injectReducer(store, {
            key: "classRoom",
            reducer,
          });
          injectReducer(store, {
            key: worksheetModule.NAME,
            reducer: worksheetModule.default,
          });
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
